<template>
  <div
    class="recharge-wrap"
    :class="{ 'recharge-wrap-dark': skinModel == '1' }"
  >
    <p class="open-sentence">
      尊敬的用户，为保障你的合法权益，请你在充值前仔细阅读《铛铛充值协议》（以下简称“本协议”）以了解铛铛的充值、零钱使用规则并避免产生任何误解。当你点击“充值”按钮，即视为你已阅读、理解本协议，并同意按照本协议约定的规则进行充值或使用零钱。
    </p>

    <div class="recharge-item">
      <p class="recharge-item-title">一、定义</p>

      <p>
        充值：你通过“铛铛”软件向你已注册的用户账号实际支付的行为；
        <br />零钱：你的用户账号中显示的余额，包括充值金额和通过铛铛领取的红包金额。
      </p>
    </div>

    <div class="recharge-item">
      <p class="recharge-item-title">二、零钱有效期</p>

      <p>用户零钱的有效期至使用完毕为止。</p>
    </div>

    <div class="recharge-item">
      <p class="recharge-item-title">三、零钱的使用规则</p>

      <p>零钱可用于铛铛账号内的支付和提现。</p>
    </div>

    <div class="recharge-item">
      <p class="recharge-item-title">四、保证与承诺</p>

      <p>
        你完全理解并同意，铛铛所提供的充值仅适用于正当、合法按照《铛铛软件许可及服务协议》在使用我们服务的用户。一旦发现你的用户账号存在任何利用前述规则从事作弊行为以获取不正当经济利益的情形，铛铛有权冻结或关闭你的用户账号、收回或追回因作弊行为取得的所有不正当的经济利益，并且铛铛保留停止向你提供服务以及根据作弊行为的严重程度进一步追究法律责任的权利。
      </p>
    </div>

    <div class="recharge-item">
      <p class="recharge-item-title">五、特别说明</p>

      <p>
        你完全理解并同意，铛铛有权随时修改本协议内容，届时将通过在官网或“铛铛”软件上公布修改后的协议，该公布将被视为铛铛已通知用户；同时，铛铛也可通过其他适当方式通知用户。如果你选择继续充值即表示你同意并接受修改后的协议并受其约束；如果你不同意我们对本协议的修改，请立即放弃充值或停止使用本服务。
        <br />在适用法律法规允许的范围内，本协议下充值使用规则的最终解释权归铛铛所有。
      </p>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  data() {
    return {
      skinModel: "0",
    };
  },
  beforeRouteEnter(to, from, next) {
    let skinModel = to.query.skinModel;
    next((vm) => {
      vm.skinModel = skinModel;
    });
  },
};
</script>

<style lang="less">
.recharge-wrap {
  padding: 20px 17px;
  color: #000000;
  font-size: 15px;
  line-height: 23px;

  .recharge-item {
    margin-top: 23px;

    p {
      margin-top: 23px;

      &.recharge-item-title {
        font-weight: 700;
      }
    }
  }

  .sign {
    font-weight: 700;
    margin-top: 35px;
    text-align: right;
  }
}

.recharge-wrap-dark {
  color: #D1D1D1;
}
</style>



// WEBPACK FOOTER //
// src/components/page/protocol/recharge.vue